import * as React from "react";
import styled from "styled-components";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { FiShare2 } from "react-icons/fi";
import { Row, Col, Container } from "react-grid-system";

import colors from "../../assets/colors/colors";

interface Props {
  data: {
    name: string;
    description: string;
    background: string;
    logo: string;
    location: string;
    id: string;
    contact: string;
  };
  colors?: any;
}

interface StyledInterface {
  color: any;
  background: string;
}

export default function Header(props: Props) {
  React.useEffect(() => {}, []);

  const handleShredData = () => {
    const shareData = {
      title: `${props.data.name}`,
      text: `Visita el menú digital de ${props.data.name}🥳`,
      url: `https://menudr.netlify.app/menu/${props.data.id}`,
    };
    navigator.share(shareData);
  };

  return (
    <ContentHeader color={colors} background={props.data.background}>
      <div className="filter">
        <div className="content">
          <Row align="center">
            <Col xs={12}>
              <div className="contentLogo">
                <img
                  src={
                    props.data.logo ||
                    "https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png"
                  }
                  alt=""
                />
              </div>
            </Col>
            <Col xs={12}>
              <div
                style={{
                  width: "100%",
                  margin: "0 auto",
                }}
              >
                <h1>{props.data.name}</h1>
                <h5>Menú</h5>
                <p>{props.data.description}</p>
                <a href={`https://wa.me/${props.data.contact}`}>
                  {props.data.contact}
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </ContentHeader>
  );
}

const ContentHeader = styled.div<StyledInterface>`
  width: 100%;
  position: relative;
  background-position: center;

  padding: 1em 1em;
  .content {
    width: 100%;

    h1 {
      font-weight: 900;
      color: ${(props) => props.color.black};
    }
    p {
      color: ${(props) => props.color.black};
      font-weight: 400;
      font-size: 16px;
    }
    .contentLogo {
      width: 100px;
      height: 100px;
      border: 1px solid white;
      bacgkround: white;
      border-radius: 5em;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5em;
      }
    }
  }
  .share {
    width: 20px;
    height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    background-color: ${(props) => props.color.black};
    opacity: 0.8;
    font-weight: bold;
    color: white;
    margin: 0 auto;
  }
`;
